//Acciones del tracking para cada registro
export const allowedActionsRow = (
  optionsMenuButton,
  setIsAnticipo,
  setIsConsuldo,
  setIsLegalize,
  setIsCauPay,
  setIsConsulDoRDO,
  setFondoCuenta,
  setFinalope,
  setGestcont,
  setIsReconMdtc,
) => {
  let actions = {};
  let rowActions = [];
  let buttonLegalize = {};
  let buttonAdvance = {};
  let buttonAdvanceProvider = {};
  let buttonCausationPayment = {};
  let buttonRdo = {};
  let buttonFinalope = {};
  let buttonGestcont = {};
  let buttonReconMdtc = {};
  Object.values(optionsMenuButton).forEach((value) => {
    switch (value.MENIDXXX) {
      case 100: //Legalizar anticipo
        buttonLegalize = {
          id: "legalize",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setIsLegalize,
        };
        break;
      case 101: //Anticipo Cliente
        buttonAdvance = {
          id: "advance",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setIsAnticipo,
        };
        break;
      case 102: //Anticipo Proveedor
        buttonAdvanceProvider = {
          //
          id: "advanceProvider",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setIsConsuldo,
        };
        break;
      case 103: //Pago Causaciones
        buttonCausationPayment = {
          id: "causationPayment",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setIsCauPay,
        };
        break;
      case 104: //RDO
        buttonRdo = {
          id: "rdo",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setIsConsulDoRDO,
        };
        break;
      case 105: //Fondo cuenta Global Wine
        buttonRdo = {
          id: "fondoCuenta",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setFondoCuenta,
        };
        break;
      case 106: //Finalizar Operacion
        buttonFinalope = {
          id: "finalope",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setFinalope,
        };
        break;
      case 109: //Gestion contable
        buttonGestcont = {
          id: "gestcont",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setGestcont,
        };
        break;
      case 110: //Reconstruir tarifas MDTC
        buttonReconMdtc = {
          id: "reconMdtc",
          title: value.OPCDESXX,
          icon: value.MENUICOX,
          handler: setIsReconMdtc,
        };
        break;
      default:
        break;
    }
  });
  return {
    ...actions,
    rowActions,
    buttonLegalize,
    buttonAdvance,
    buttonAdvanceProvider,
    buttonCausationPayment,
    buttonRdo,
    buttonFinalope,
    buttonGestcont,
    buttonReconMdtc,
  };
};
